import React, { Component } from 'react';

import { Layout, Icon } from 'antd';
import { NavBarTrigger, AvatarMenu } from '../index';

import './navbar.css';

const { Header } = Layout;

/* 
    Note this componente can receive images like .png or .jpg to logo or 
        just and string to be showed in the bar, just using the props LOGO or TEXTLOGO.
    That Component has an initial strucuture that can alow show an trigger menu, 
    an logo and an basic user menu, but note that user menu start empty, so you have to pass 
    the component that will compose the menu dropdown.

*/


class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
        };
    }

    handleWindowResize = ({currentTarget}) => {
        this.setState({ width: currentTarget.innerWidth });
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    render() {
        const { width } = this.state;
        const { logo, textLogo, loadingtextLogo, children, alt, menu, triggerFunc, className, style, collapsed } = this.props;
        
        return (
            <Layout>
                {!children &&
                    <Header className={`Navbar ${className ? className : ''}`} style={{ ...style }}>
                        <section className='bar-left'>
                            {(triggerFunc && width <= 768) &&
                                <NavBarTrigger className={'white'} collapsed={collapsed} onClick={triggerFunc} />
                            }

                            {logo && <img className='brand-navbar' src={logo} alt={alt} />}

                            {loadingtextLogo ? 
                                <Icon type='sync' className="icon-value" spin={true} /> : 
                                width >= 768 &&
                                    <label className='text-logo'> Bem Vindo(a), <em>{textLogo} </em> !</label>
                            }
                        </section>
                        <section className='bar-right'>
                            <AvatarMenu>{menu}</AvatarMenu>
                        </section>
                    </Header>
                }

                {children &&
                    <Header className='Navbar'>
                        {children}
                    </Header>
                }

            </Layout>
        );
    }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/App/components/navbar/navbar.js